import $store from '@/store'

export default [
  {
    path: '/signup',
    component: () => import('@/pages/signup/Index.vue'),
    children: [
      {
        name: 'signup',
        path: '',
        meta: { requireSignin: false },
        redirect: 'register',
      },
      {
        name: 'signup/register',
        path: 'register',
        meta: {
          requireSignin: false,
          ui: {
            newHeader: true,
            header: {
              backButton: true,
              progressBar: true,
              title: '회원가입',
            },
            classes: ['px-0'],
          },
        },
        component: () => import('@/pages/signup/Signup.vue'),
      },
      {
        name: 'signup/mall',
        path: 'mall/:provider?',
        meta: {
          ui: {
            bottomless: true,
            newHeader: true,
            classes: ['px-0'],
          },
        },
        props: true,
        component: () => import('@/pages/signup/SignupMall.vue'),
      },
      {
        name: 'signup/mall/two-factor-auth',
        path: 'mall/:provider/two-factor-auth',
        meta: {
          requireSignin: false,
          ui: {
            bottomless: true,
            newHeader: true,
            classes: ['px-0'],
          },
        },
        props: true,
        component: () => import('@/pages/signup/mall/TwoFactorAuthMall.vue'),
      },
      {
        name: 'signup/auth/phone',
        path: 'auth',
        beforeEnter(to, from, next) {
          if (!!$store.getters['signup/getRegisterForm']) {
            next()
            return
          } else {
            next({ name: 'signup' })
            return
          }
        },
        meta: { requireSignin: false },
        props: true,
        component: () => import('@/pages/signup/AuthPhone.vue'),
      },
    ],
  },
  {
    name: 'signup/prefilled',
    path: '/signup/prefilled',
    meta: { requireSignin: false },
    component: () => import('@/pages/signup/Prefilled.vue'),
  },
  {
    name: 'signup/complete',
    path: '/signup/complete',
    meta: {
      ui: {
        bottomless: true,
        newHeader: true,
        classes: ['px-0'],
      },
    },
    component: () => import('@/pages/signup/SignupComplete.vue'),
  },
  {
    name: 'signup/platform/require',
    path: '/signup/platform/require',
    meta: {
      ui: {
        bottomless: true,
        newHeader: true,
        classes: ['px-0'],
      },
    },
    component: () => import('@/pages/signup/RequirePlatform.vue'),
  },
  {
    name: 'signup/platform/notavailable',
    path: '/signup/platform/notavailable',
    meta: {
      ui: {
        bottomless: true,
        newHeader: true,
        classes: ['px-0'],
      },
    },
    component: () => import('@/pages/signup/NotAvailablePlatform.vue'),
  },
]
